import PropTypes from 'prop-types';
import { listing as listingType } from './proptypes/index';
import Heading from './show/heading';
import AboutSection from './show/about_section';
import CapabilitiesSection from './show/capabilities_section';
import Sidebar from './show/sidebar';

const AppListing = ({ listing, isAlreadyUser }) => {
  return (
    <div className="appListing">
      <Heading listing={listing} isAlreadyUser={isAlreadyUser} />

      <div className="container content flex">
        <div className="left-content">
          <AboutSection listing={listing} />

          {listing.capability_groups && listing.capability_groups.length > 0 && (
            <CapabilitiesSection
              appName={listing.name}
              capabilityGroups={listing.capability_groups}
            />
          )}
        </div>

        <div className="right-content">
          <Sidebar listing={listing} />
        </div>
      </div>
    </div>
  );
};

AppListing.propTypes = {
  listing: listingType.isRequired,
  isAlreadyUser: PropTypes.bool,
};

AppListing.defaultProps = {
  isAlreadyUser: false,
};

export default AppListing;
